var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcNewTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5F6767F6-3E72-4795-8870-E9BB4A66D26F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Uzdotie-jaut\\u0101jumi",
    transform: "translate(-600.000000, -437.000000)",
    fill: "#0883EF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-1",
    transform: "translate(260.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(30.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Item-2",
    transform: "translate(0.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About",
    transform: "translate(0.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(56.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Link-(New-tab)",
    transform: "translate(216.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(38.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,0 C1.77614237,0 2,0.223857625 2,0.5 C2,0.745459889 1.82312484,0.94960837 1.58987563,0.991944331 L1.5,1 C1.22385763,1 1,1.22385763 1,1.5 L1,6.5 C1,6.77614237 1.22385763,7 1.5,7 L6.5,7 C6.74545989,7 6.94960837,6.82312484 6.99194433,6.58987563 L7,6.5 C7,6.22385763 7.22385763,6 7.5,6 C7.77614237,6 8,6.22385763 8,6.5 C8,7.32842712 7.32842712,8 6.5,8 L1.5,8 C0.671572875,8 0,7.32842712 0,6.5 L0,1.5 C0,0.671572875 0.671572875,0 1.5,0 Z M3.5,0 L7.5,0 L7.5534276,0.00282096186 L7.62814577,0.0166082551 L7.69103656,0.0377922373 L7.76701032,0.0771880058 L7.82213721,0.117583716 L7.85355339,0.146446609 L7.88918436,0.186030673 L7.93173127,0.247616133 L7.96914516,0.326670739 L7.98826554,0.39202251 L8,0.5 L8,4.5 C8,4.77614237 7.77614237,5 7.5,5 C7.22385763,5 7,4.77614237 7,4.5 L7,1.706 L3.85355339,4.85355339 C3.65829124,5.04881554 3.34170876,5.04881554 3.14644661,4.85355339 C2.95118446,4.65829124 2.95118446,4.34170876 3.14644661,4.14644661 L6.292,1 L3.5,1 C3.25454011,1 3.05039163,0.823124839 3.00805567,0.589875632 L3,0.5 C3,0.223857625 3.22385763,0 3.5,0 Z",
    id: "icon"
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewTab);
export default __webpack_public_path__ + "static/media/ic-new-tab.f2d0ad7e4dcadc7af8c1acac327bedf4.svg";
export { ForwardRef as ReactComponent };